import { Grid, Typography } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import AcxMainTextField from "components/UI/AcxMainTextField";

interface ModifyPromptTemplateProps {
    defaultValue?: string;
    children?: React.ReactNode;
    onSave: (template: string) => void;
    saveLabel?: React.ReactNode;
    disabled?: boolean;
}

export const ModifyPromptTemplate = observer(
    (props: ModifyPromptTemplateProps) => {
        const [localTemplate, setLocalTemplate] = useState(props.defaultValue);
        const [
            isModifyPromptTemplateDialogOpen,
            setIsModifyPromptTemplateDialogOpen,
        ] = useState(false);

        useEffect(() => {
            setLocalTemplate(props.defaultValue);
        }, [props.defaultValue]);

        return (
            <>
                <AcxButton
                    onClick={() => setIsModifyPromptTemplateDialogOpen(true)}
                    disabled={!props.defaultValue || props.disabled}
                >
                    {props.children ?? "Modify prompt template"}
                </AcxButton>
                <AcxDialog
                    isOpen={isModifyPromptTemplateDialogOpen}
                    onClose={() => {
                        setIsModifyPromptTemplateDialogOpen(false);
                        setLocalTemplate(props.defaultValue);
                    }}
                    title="Prompt Template"
                    maxWidth="xl"
                    contentWidth="50dvw"
                    dialogContentChildren={
                        <Grid container direction="column" rowGap={1}>
                            <Grid item>
                                <Typography>
                                    Do not modify anything enclosed in squirly
                                    braces
                                </Typography>
                            </Grid>
                            <Grid item>
                                <AcxMainTextField
                                    id="llm-prompt-template-value"
                                    multiline
                                    value={localTemplate}
                                    onChange={(event) =>
                                        setLocalTemplate(event.target.value)
                                    }
                                    rows={16}
                                    rowsMax={20}
                                    sx={(theme) => ({
                                        paddingLeft: theme.spacing(1),
                                    })}
                                />
                            </Grid>
                        </Grid>
                    }
                >
                    <AcxButton
                        onClick={() => {
                            props.onSave(localTemplate!);
                            setIsModifyPromptTemplateDialogOpen(false);
                        }}
                    >
                        {props.saveLabel ?? "Save"}
                    </AcxButton>
                </AcxDialog>
            </>
        );
    },
);
